export default "__VITE_ASSET__lVJ3mf6N__"